import { getLogo } from '@/utils/intConfiguration';

// 使用注册名称，不根据当前页面或路由猜测身份。
export const microAppSides = Object.freeze({
  microAppCustomerSaas: 'customer',
  microAppScmCapital: 'merchant',
});

export const isCmhub = () => String(process.env.NODE_ENV === 'development'
  ? localStorage.getItem('appId') : getLogo().appId) === '10025';

export const resourceApis = {
  customer: {
    menus: '/client-bff/v1/account/menu/list',
    permissions: '/client-bff/v1/account/resource/list',
  },
  merchant: {
    menus: '/infrastructure-authority/v1/account/menu/list',
    permissions: '/infrastructure-authority/v1/account/resource/list',
  },
};
